export default "__VITE_ASSET__e79f294e__"